module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0063.jpg?v=a8a5c18c";